import { useContext } from 'react';

import {
  ScrollableDialogContent,
  CloseDialogButton,
} from '@cast/design-system';

import { useCastAnywhereClusterPricingQuery } from 'hooks/queries/pricing';

import { ConnectedState } from '../../../../_components/ConnectedState';
import { StepContainer } from '../../../../_components/new-onboarding';
import { SetupCastAnywhere } from '../../../../_components/SetupCastAnywhere';
import { OnboardClusterContext } from '../../../OnboardClusterProvider';

export const ConfigureCastAnywhereStep = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const { newCluster } = useContext(OnboardClusterContext);
  const { clusterPricing } = useCastAnywhereClusterPricingQuery({
    organizationId: newCluster?.organizationId,
    clusterId: newCluster?.id,
  });

  return (
    <StepContainer position="relative">
      <CloseDialogButton onClose={onClose} />

      <ScrollableDialogContent sx={{ p: 24, pb: 16 }}>
        <ConnectedState cluster={newCluster} />
      </ScrollableDialogContent>

      <SetupCastAnywhere
        cluster={newCluster!}
        pricing={clusterPricing}
        showComingSoonFields
      />
    </StepContainer>
  );
};
